import React, { useCallback } from 'react';
import type { Command } from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useTransformNavigationCommands } from '../../../utils/transform-navigation-commands';
import { ProjectLeftIcon } from './project-left-icon';
import type { ProjectCommandProps } from './types';

export const useGetProjectCommand = () => {
	const { transformNavigationCommand } = useTransformNavigationCommands();

	const getProjectCommand = useCallback(
		({ project, keywords, section, analytics, ...rest }: ProjectCommandProps): Command | null => {
			const { projectId, name, url, avatar, canView } = project;
			if (!canView) {
				return null;
			}
			return transformNavigationCommand(
				{
					id: `project-${projectId}`,
					section,
					keywords,
					name,
					components: {
						LeftIcon: () => <ProjectLeftIcon url={avatar.url} name={name} />,
					},
					analytics: {
						action: 'projectViewed',
						projectId,
						metadata: {
							contentId: projectId,
							containerId: 'UNAVAILABLE',
							contentType: 'project',
						},
						...analytics,
					},
					...rest,
				},
				{ path: url },
			);
		},
		[transformNavigationCommand],
	);

	return { getProjectCommand };
};
